import {
    Box,
    Image,
} from "@chakra-ui/react";

import DriverPartnerImage from "../../../../assets/partner.png";

const LoginShowcase = () => {
    return (
        <Box
            bg="#F5F8FF"
            h="100%"
            display="flex"
            alignItems="center"
            justifyContent="center"
            p={10}
            borderTopLeftRadius="40px"
            borderBottomLeftRadius="40px"
            overflow="hidden"
        >
            <Image
                src={DriverPartnerImage}
                alt="Driver Partner"
                w="100%"
                maxW="700px"
                objectFit="contain"
            />
        </Box>
    );
};

export default LoginShowcase;